export var RoleSystemNameEnum;
(function (RoleSystemNameEnum) {
    RoleSystemNameEnum["CHW"] = "Community Health Worker";
    RoleSystemNameEnum["TeamLead"] = "Team Lead";
    RoleSystemNameEnum["SuperAdmin"] = "Super Admin";
    RoleSystemNameEnum["Administrator"] = "Administrator";
})(RoleSystemNameEnum || (RoleSystemNameEnum = {}));
export var RoleDefaultNameEnum;
(function (RoleDefaultNameEnum) {
    RoleDefaultNameEnum["CHW"] = "Community Health Worker";
    RoleDefaultNameEnum["TeamLead"] = "Team Lead";
    RoleDefaultNameEnum["SuperAdmin"] = "Super Admin";
    RoleDefaultNameEnum["Administrator"] = "Administrator";
})(RoleDefaultNameEnum || (RoleDefaultNameEnum = {}));
//# sourceMappingURL=role-system-names.js.map